<script>
  import { page } from '@inertiajs/svelte'
  import { marked } from 'marked'

  import Main from "../layouts/_main.svelte"
  import KintounContext from "./_kintoun_context.svelte"

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  import {
    blog_path
  } from '../../javascript/routes'

  let { RailsApp, post, content } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  // Custom renderer
  const renderer = new marked.Renderer()
  renderer.heading = function({ tokens, depth }) {
    const text = this.parser.parseInline(tokens)
    if (depth === 2) {
      return `<h2 class="mt-2 mb-3">${text}</h2>`
    }
    return `<h${depth}>${text}</h${depth}>`
  }
  renderer.image = function({ href, title, text }) {
    const hasRetina = href && !href.includes('@2x.') && href.match(/\.(webp|png|jpe?g)$/i)
    const srcset = hasRetina ? ` srcset="${href} 1x, ${href.replace(/\.(webp|png|jpe?g)$/i, '@2x.$1')} 2x"` : ''
    return `<a href="${href}" target="_blank" class="d-inline-block mw-100"><img src="${href}"${srcset} alt="${text}" title="${title || text}" class="img-fluid border shadow-sm" /></a>`
  }

  // Wrap content between h2 tags in <section> elements
  function wrapSections(html) {
    const parts = html.split(/(?=<h2)/)
    return parts.map(part => {
      if (part.trim()) {
        return `<section>${part}</section>`
      }
      return part
    }).join('')
  }

  const htmlContent = $derived(wrapSections(marked(content, { renderer })))

  function formatDate(dateString) {
    const date = new Date(dateString)
    return date.toLocaleDateString(RailsApp.I18n.locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }
</script>

<Main {...$page.props}>
  <article class="container py-5">

    <nav class="mb-4">
      <a href={blog_path({ locale: RailsApp.I18n.locale })} class="text-muted text-decoration-none">
        <i class="bi bi-arrow-left me-1"></i>
        {i18n.t('Blog.title', { defaultValue: 'Blog' })}
      </a>
    </nav>

    <header class="mb-4">
      <h1 class="mb-2">{post.title}</h1>
      <p class="text-muted">
        {formatDate(post.publishedAt)}
      </p>
    </header>

    <KintounContext
      title={i18n.t('Blog.Show.context.title')}
      description={i18n.t('Blog.Show.context.description')}
    />

    <div class="markdown-body d-flex flex-column gap-3 gap-md-4">
      {@html htmlContent}
    </div>

    <footer class="mt-5 pt-4 border-top">
      <a href={blog_path({ locale: RailsApp.I18n.locale })} class="elementary-btn elementary-btn-blue">
        <i class="bi bi-arrow-left me-2"></i>
        {i18n.t('Blog.Show.back_to_list', { defaultValue: 'Back to blog' })}
      </a>
    </footer>
  </article>
</Main>
